export default {
  heading: "忘 记 密 码",
  typeHint: "请选择输入电邮地址<font color='#FF0000'>或</font>登入名称：",
  emailRadioLabel: "登入电邮<font color='#FF0000'>或</font>联络电邮",
  cityIdRadioLabel: "登入名称",
  emailLabel: "登入电邮或联络电邮",
  cityIdLabel: "登入名称",
  submitBtn: "确定",
  resetBtn: "重设",
  closeBtn: "关闭",
  emailIsEmpty: "请输入您的电邮地址。",
  cityIdIsEmpty: "请输入您的登入名称。",
  emailFormatWrong: "电邮地址格式不正确，请重新输入。",
  recaptcha_lang: "zh-HK",
  emailNotFound: "找不到此电邮地址。请检查您所输入的电邮地址是否正确。",
  cityIdNotFound: "找不到此教城帐户。请检查您所输入的帐户是否正确。",
  accountNoEmail: "系统找不到您的登记电邮或联络电邮的记录，请联络您的学校管理员重设密码。",
  completed:
    "我们已将设定新密码的连结寄到以下的电邮地址：",
};
